module.exports = __webpack_public_path__ + "Flaticon.0a9cd90d8b330052c672.svg";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/flaticon/Flaticon.svg
// module id = ../../../../../src/assets/vendors/base/fonts/flaticon/Flaticon.svg
// module chunks = styles